import React from 'react'

import { Card } from 'primereact/card'
import { Message } from 'primereact/message'
import { Button } from 'primereact/button'
import { AutoComplete } from 'primereact/autocomplete'
import { Fieldset } from 'primereact/fieldset'

  import { InputText } from 'primereact/inputtext'
// wrappers for prime react form fields
import FieldInputText from '../common/FieldInputText'
import FieldInputTextarea from '../common/FieldInputTextarea'
import FieldCalendar from '../common/FieldCalendar'
import FieldCheckbox from '../common/FieldCheckbox'
import FieldDropdown from '../common/FieldDropdown'
import FieldFileUpload from '../common/FieldFileUpload'
import FieldPassword from '../common/FieldPassword'
import FieldHelpText from '../common/FieldHelpText'
import { Checkbox } from "primereact/checkbox";

import * as candidateBoardActionCreators from "../../actionCreators/candidateBoard"
import CandidateBoard from '../../container/CandidateBoard'
import ConfirmDialog from '../common/ConfirmDialog'

import '../../css/candidate-details.css'



const PersonalDetails = ({ currentCandidate, showAsTextOnly, validationRules, genders,candidateDetailsIntroText,titleHelpText, showHelpText  }) => {
  let isAdd = !currentCandidate.CandidateId
  const personalDetailsHeader = <h2 className="p-card-title">Personal Details</h2>;
  return (
    <div id="personalDetails">

    <p>
              <span
                  // className={"home-page-text"}
                  dangerouslySetInnerHTML={{
                      __html: candidateDetailsIntroText
                  }}
              />
    </p>  
    <Card header={personalDetailsHeader} aria-label="Personal Details" tabIndex="0">
  
        <Message tabIndex="0" aria-label="Fields marked with an asterisk (*) are mandatory" style={{ width: '100%' }} className="inforText" severity="" text={<span>Fields marked with an asterisk (<span style={{color: 'red'}}>*</span>) are mandatory</span>}></Message>

          <br />
          <br />

       <div   className="p-grid">    

        <div className="p-col-12" >
               <label htmlFor={'Title'} style={{fontWeight:"bold", marginLeft:"2px", marginBottom:"7px", display: "inline-block"}} >Title</label>  
               <Button id="helpTitleIconBtn" aria-expanded="false" className="helpIconBtns" icon="pi pi-info-circle" iconPos="left" onClick={(e) => showHelpText(e, 'TITLE')} />
                 {titleHelpText? <FieldHelpText  helpText={titleHelpText}/> : ""} 
            <FieldInputText field={"Title"} label={"Title"} showLabel={"false"} aria-label="Title" autoFocus="true" autoComplete="honorific-prefix" validationRules={validationRules} showAsTextOnly={showAsTextOnly} inputStyle={{ maxWidth: 150 }} />
                             
        </div>
        <div className="p-col-12">
          <FieldInputText  field={"GivenName"} label={"First Name"} aria-label="First Name" autoComplete="given-name" validationRules={validationRules} showAsTextOnly={showAsTextOnly} inputStyle={{ maxWidth: 280 }} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"PreferredName"} label={"Preferred Name (if any)"} aria-label="Preferred Name (if any)" autoComplete="nickname" validationRules={validationRules} showAsTextOnly={showAsTextOnly} inputStyle={{ maxWidth: 280 }} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"MiddleNames"} label={"Middle Name(s)"} aria-label="Middle Name(s)" autoComplete="additional-name" validationRules={validationRules} showAsTextOnly={showAsTextOnly} inputStyle={{ maxWidth: 280 }} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"FamilyName"} label={"Last Name"} aria-label="Last Name" autoComplete="family-name" validationRules={validationRules} setValueAsUpperCase={true} showAsTextOnly={showAsTextOnly} inputStyle={{ maxWidth: 280 }} />
        </div>
        <div className="p-col-12">
          <FieldCalendar field={"DateOfBirth"} label={"Date of Birth (dd/mm/yyyy)"}  aria-label="Date Of Birth (dd/mm/yyyy)" autoComplete="bday" tabIndex="0" validationRules={validationRules} viewDate={currentCandidate.DateOfBirth} showAsTextOnly={showAsTextOnly} inputStyle={{ maxWidth: 120 }} />
        </div>
        <div className="p-col-12">
            <FieldDropdown field={"GenderLookup"} aria-label="Gender" data-toggle="dropdown" autoComplete="sex" label={"Gender"}  options={genders} validationRules={validationRules} showAsTextOnly={showAsTextOnly} inputStyle={{ width: 120 }} /> 
        </div>
        <div className="p-col-12"  />        
        <Fieldset legend="Do you identify as any of the following" className="p-col-12 field-label-checkbox-container"   style={ {maxWidth: 600,marginLeft: "12px"} }>        
        <div className="p-col-12">
          <FieldCheckbox id={"AboriginalFlag"} field={"AboriginalFlag"} label={"Aboriginal or Torres Strait Islander"} aria-label={"Aboriginal or Torres Strait Islander"} tabIndex="0" validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-col-12">
          <FieldCheckbox id={"WithDisabilityFlag"} field={"WithDisabilityFlag"} label={"A person with a disability"} aria-label={"A person with a disability"} tabIndex="0" validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-col-12">
          <FieldCheckbox id={"CulturalBackgroundFlag"} field={"CulturalBackgroundFlag"} label={"Culturally and Linguistically Diverse background"}  aria-label={"Culturally and Linguistically Diverse background"} tabIndex="0" validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        </Fieldset>
      </div>
    </Card>
     </div>
  )
}

const ContactDetails = ({ currentCandidate, showAsTextOnly, validationRules }) => {
  let isAdd = !currentCandidate.CandidateId
  const contactInformationHeader = <h2 className="p-card-title">Contact Information</h2>;
  return (
    <div id="contactInformation">
    <Card header={contactInformationHeader} >
      <div  className="p-grid">
        {isAdd === false && <div className="p-col-12">
          <FieldInputText field={"Email"} label={"Email"} aria-label="Email" autoComplete="email" validationRules={validationRules} showAsTextOnly={showAsTextOnly} inputStyle={{ maxWidth: 280 }}  />
        </div>}
        <div className="p-col-12">
          <FieldInputText inputStyle={{ maxWidth: 280 }} field={"ContactNo"} autoComplete="tel-national" aria-label=" Preferred Contact Number" label={"Preferred Contact Number "} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-col-12">
          <FieldInputTextarea rows={3} inputStyle={{ maxWidth: 590 }} field={"Address"} autoComplete="street-address" aria-label="Address or PO Box" label={"Address or PO Box"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"Suburb"} inputStyle={{ maxWidth: 280 }} label={"Suburb"} autoComplete="address-level2" aria-label="Suburb" validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-grid" style={{ marginLeft: 0 }} >
        <div className="p-md-5 p-sm-6">
          <FieldInputText inputStyle={{ maxWidth: 280 }} field={"State"} label={"State or Territory"} autoComplete="address-level1" aria-label="State or Territory" validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        <div className="p-md-5 p-sm-6">
          <FieldInputText inputStyle={{ maxWidth: 280}} field={"PostCode"} label={"Postcode"} autoComplete="postal-code" aria-label="Postcode" validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        </div>
      </div>
    </Card>
    </div>
  )
}

const EmploymentDetails = ({ currentCandidate, showAsTextOnly, validationRules, cvUpload, downloadCv, removeCv, skillsAutocomplete, qualificationsAutocomplete, isGovernment, candidateBoards, updateCandidateBoards, stateGovtEmployeeLink,showBoardExpirience,showHelpText,linkedInHelpText,canSave }) => {
  let isAdd = !currentCandidate.CandidateId
  let personalLink = currentCandidate.LinkedInUrl ? true: false
  let uploadCVlabel =  currentCandidate.CandidateCvFileName? <span><span>Upload a CV </span><span className="unbolded-text">(PDF  Formats Only) This will replace your currently uploaded CV</span></span> :
   <span><span>Upload a CV </span><span className="unbolded-text">(PDF Formats Only)</span></span> 

  const employmentDetailsHeader = <h2 className="p-card-title">Employment</h2>;


  return (
    <div id="employmentDetails">
    <Card header={employmentDetailsHeader} >
      <div  className="p-grid">        
        <div className="p-col-12">
          <FieldInputText field={"CurrentJobTitle"} label={"Job Title"} aria-label="job title" validationRules={validationRules} showAsTextOnly={showAsTextOnly}  inputStyle={{ maxWidth: 600 }}/>
        </div>
        {/* <div className="p-col-12">
          <FieldInputText field={"CurrentEmployer"} label={"Employer"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div> */}
        <div className="p-col-12">
          <FieldInputTextarea rows={3} field={"CurrentEmployerNameAndAddress"} label={"Employer Name and Address"} aria-label="Employer Name and Address" validationRules={validationRules} showAsTextOnly={showAsTextOnly} inputStyle={{ maxWidth: 600 }} />
        </div>
        <div className="p-col-12">
           <label style={{fontWeight:"bold", marginLeft:"3px"}} aria-label="Online Profile Link">Online Profile Link</label>  
            <Button id="helpOnlineProfileLinkIconBtn" aria-expanded="false" className="helpIconBtns" icon="pi pi-info-circle" iconPos="left" onClick={(e) => showHelpText(e, 'LINKEDINURL')} />
             {linkedInHelpText? <FieldHelpText helpText={linkedInHelpText}/> : ""}

          {showAsTextOnly === false && <FieldInputText field={"LinkedInUrl"}validationRules={validationRules} showAsTextOnly={showAsTextOnly}   inputStyle={{ maxWidth: 600 }} />}
          {showAsTextOnly && personalLink &&  <div className="p-col-12"><a href={currentCandidate.LinkedInUrl} target="_blank">{currentCandidate.LinkedInUrl}</a> </div>  }
          {showAsTextOnly && personalLink===false && <FieldInputText field={"LinkedInUrl"}validationRules={validationRules} showAsTextOnly={showAsTextOnly}   inputStyle={{ maxWidth: 600 }} /> }
        </div>

        <div className="p-col-12" />
        <div className="p-col-12">
           <FieldCheckbox field={"SaGovEmployeeFlag"} label={<span>Tick if you are a South Australian State Government employee (as defined in section 2 of <a href={stateGovtEmployeeLink} target="_blank">  Premier and Cabinet Circular PC016</a>)</span> } validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
        {isAdd === false && currentCandidate.CandidateCvFileName && <div className="p-g-12 p-md-12 p-lg-12 p-uploaded-cv">
          Currently Uploaded CV
                    </div>}
        {currentCandidate.CandidateCvFileName && <div className="p-g-12 p-md-12 p-lg-12">
          <Button onClick={(e) => downloadCv(e, currentCandidate.CandidateId)} icon="pi pi-cloud-download" label={"Download " + currentCandidate.CandidateCvFileName}> </Button>
          <ConfirmDialog buttonLabel="Remove CV" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={(e) => removeCv(e, currentCandidate.CandidateId)}
              title={'Confirm removing CV'} message={'Do you want to remove your CV?'}/>      
        </div>}
        {isGovernment === false && showAsTextOnly === false && <div className="p-col-12 p-md-12 p-lg-12">
          <FieldFileUpload field={"CandidateCv"} name="CandidateCv" accept=".pdf" uploadRef={cvUpload} label={uploadCVlabel} hasSavedFile={currentCandidate.CvExists}
            validationRules={validationRules} />
        </div>}
       {/* <div className="p-col-12 field-element-container">
           <Checkbox inputId="cb1" checked={showBoardExpirience} value={showBoardExpirience} onChange={(e) => showHelpText(e, 'BOARDEXPIRIENCE')}  />
            <label aria-label="cb1" className="p-checkbox-label" style={{marginLeft:"0px"}}>Tick View/Add Board experience</label>
        </div> */}
           {<CandidateBoard canSave={canSave} candidateId={currentCandidate.CandidateId}  candidateBoards={candidateBoards} updateCandidateBoards={updateCandidateBoards}  />}
      </div>
    </Card>
    </div>
  )
}




const SkillsAndQualifications = ({ currentCandidate, showAsTextOnly, validationRules, skillsAutocomplete, qualificationsAutocomplete, isGovernment, skillsExpertiseHelpText,anyCommentsHelpText, qualificationsHelpText, showHelpText  }) => {
  let isAdd = !currentCandidate.CandidateId
  let skillsPlaceholder = showAsTextOnly === false ? "Start typing to choose from available skills in the drop-down list": ""
  let qualificationsPlaceholder = showAsTextOnly === false ? "Start typing to choose from available qualifications in the drop-down list": ""
  const skillsAndQualificationsHeader = <h2 className="p-card-title">Skills, Expertise and Qualifications</h2>;
  
  
  

  //let el = document.getElementById('close-button');
//console.log(el.ariaLabel); // "Close"
//el.ariaLabel = "Close dialog"
//console.log(el.ariaLabel); // "Close dialog"


  return (
    <div id="skillsAndQualifications">
    <Card header={skillsAndQualificationsHeader} >
      <div   className="p-grid">        
        <div id="bc-skills-or-expertise" className="p-col-12">
          <div className="p-grid">
            <div className="p-col-12 field-label-container">
              <label tabIndex="0">
                Skills or Expertise
              </label>
              <Button aria-expanded="false" tabIndex="0" className="helpIconBtns"   icon="pi pi-info-circle" iconPos="left" id="helpSkillIconBtn" onClick={(e) => showHelpText(e, 'SKILLS')} />
              {skillsExpertiseHelpText? <FieldHelpText helpText={skillsExpertiseHelpText}/> : ""}
             </div>

            <div className="p-col-12 field-element-container">
              <AutoComplete value={skillsAutocomplete.values} tabIndex={0} aria-label={skillsAutocomplete.values} suggestions={skillsAutocomplete.filteredOptions} style={{ width: '100%' }}
              completeMethod={skillsAutocomplete.filterMethod} minLength={1} field="Description" multiple={true} 
              onChange={skillsAutocomplete.onChange} disabled={showAsTextOnly} className={showAsTextOnly ? 'show-text-only' : ''}
              placeholder={skillsPlaceholder} inputStyle={{width: '30em'}} />              
            </div>
          </div>
        </div>
        <div id="bc-qualifications" className="p-col-12">
          <div className="p-grid">
            <div className="p-col-12 field-label-container">
              <label tabIndex="0">
                Qualifications
              </label>
             <Button id="helpQualiIconBtn" aria-expanded="false"  className="helpIconBtns" icon="pi pi-info-circle" iconPos="left" onClick={(e) => showHelpText(e, 'QUALIFICATIONS')} />
              {qualificationsHelpText? <FieldHelpText helpText={qualificationsHelpText}/> : ""}

             </div>
            <div className="p-col-12 field-element-container">
              <AutoComplete value={qualificationsAutocomplete.values} tabIndex={0} aria-label={qualificationsAutocomplete.values} suggestions={qualificationsAutocomplete.filteredOptions} style={{ width: '100%' }}
              completeMethod={qualificationsAutocomplete.filterMethod} minLength={1} field="Description" multiple={true} 
              onChange={qualificationsAutocomplete.onChange} disabled={showAsTextOnly} className={showAsTextOnly ? 'show-text-only' : ''} 
              placeholder={qualificationsPlaceholder} inputStyle={{width: '35em'}} />
            </div>
          </div>
          <br />

           <div className="p-grid">
            <div className="p-col-12 field-label-container">
              <label>
                Any comments or additional information?
              </label>
              <Button className="helpIconBtns" aria-expanded="false" icon="pi pi-info-circle" iconPos="left" id="helpAnyCommentsIconBtn" onClick={(e) => showHelpText(e, 'ANYCOMMENTS')} />
              {anyCommentsHelpText? <FieldHelpText helpText={anyCommentsHelpText}/> : ""}

            </div>
          </div>
          <FieldInputTextarea rows={6} field={"AdditionalInfo"} label={""} validationRules={validationRules} showAsTextOnly={showAsTextOnly} maxLength={2000}  />
          </div>      

     
      </div>

    </Card>
    </div>
  )
}


const loginSectionHeader = <h2 className="p-card-title">Create your login credentials</h2>;
const LoginDetails = ({ validationRules, showAsTextOnly, isAdd }) => {
  return (
    <div id="loginSection">
    <Card header={loginSectionHeader} >
      <div  className="p-grid">
        <div className="p-col-12">
          <Message style={{ width: '100%' }} severity="" text="Email address and password entered will be used to access the register."></Message>
        </div>
        <div className="p-col-12">
          <FieldInputText field={"Email"} label={"Email"} aria-label="Email" validationRules={validationRules} showAsTextOnly={showAsTextOnly}   inputStyle={{ maxWidth: 280 }} />
        </div>
        {isAdd && <div className="p-col-12">
          <Message style={{ width: '100%' }} severity="" text="Password must be at least 8 characters, contain 1 digit, contain 1 uppercase letter and contain 1 lowercase letter."></Message>
        </div>}
        <div className="p-col-12">
          <FieldPassword field={"NewPassword"} label={"Password"} aria-label="Password" validationRules={validationRules}  inputStyle={{ maxWidth: 280 }}  />
        </div>
        <div className="p-col-12">
          <FieldPassword field={"ConfirmPassword"} label={"Confirm Password"} aria-label="Confirm Password" validationRules={validationRules}  inputStyle={{ maxWidth: 280 }}  />
        </div>
      </div>
    </Card>
    </div>
  )
}

const communicationsSectionHeader = <h2 class="p-card-title">Record of Communications</h2>;
const CandidateCommunications = ({ validationRules,communicationsHelpText,showHelpText }) => {
  return (
    <div id="communicationsSection" >
    <Card header={loginSectionHeader} >
     {/* <div className="p-grid">*/}
        <div className="p-grid">
        <div className="p-col-12">
               <label style={{fontWeight:"bold", marginLeft:"3px"}} aria-label="Summary of communications with this candidate">Summary of communications with this candidate</label>  
               <Button id="helpSummaryIconBtn" aria-expanded="false" className="helpIconBtns" icon="pi pi-info-circle" iconPos="left" onClick={(e) => showHelpText(e, 'COMMUNICATIONS')} />
               {communicationsHelpText?<FieldHelpText helpText={communicationsHelpText}/> : ""}
          <FieldInputTextarea rows={3} field={"CandidateCommunications"} label={""} validationRules={validationRules} showAsTextOnly={false} />
        </div>   
        </div>   
     {/* </div>*/}
    </Card>
    </div>
  )
}

const rejectReasonHeader = <h2 class="p-card-title">Reject Reason</h2>;
const RejectReason = ({ showAsTextOnly, validationRules }) => {
  return (
    <div id="rejectSection">
    <Card header={rejectReasonHeader}>
      <div className="p-grid">
        <div className="p-col-12 p-md-12 p-lg-12">
          <FieldInputTextarea rows={3} field={"RejectReason"} label={"Reject Reason"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
      </div>
    </Card>
    </div>
  )
}

const declarationSectionHeader = <h2 className="p-card-title">Declaration</h2>;
const Declaration = ({ showAsTextOnly, validationRules,declarationText }) => {
  return (
    <div id="declarationSection">
    <Card header={declarationSectionHeader} subTitle="By submitting this registration:" >
      <div className="p-grid">
        <div className="p-col-12 p-md-12 p-lg-12">
              <span className="p-declaration-list"> <span
                  dangerouslySetInnerHTML={{
                   __html: declarationText
                       }}
                   />
                   </span>
          <br />          
        <FieldCheckbox field={"CandidateDeclarationFlag"} label={" I declare that the information I have provided is true and accurate and I agree to the terms."} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
      </div>
    </Card>
    </div>
  )
}


const CandidateDetails = ({ currentCandidate, canSave, genders, cvUpload, downloadCv, removeCv, qualificationsAutocomplete, 
     skillsAutocomplete, isAdmin, isGovernment, candidateBoards, updateCandidateBoards,
     candidateDetailsIntroText, stateGovtEmployeeLink, qualificationsHelpText, skillsExpertiseHelpText, showHelpText, titleHelpText,
     showBoardExpirience, linkedInHelpText,anyCommentsHelpText,declarationText, communicationsHelpText }) => {
  let validationRules = currentCandidate.ValidationRules ? currentCandidate.ValidationRules.$values : []

  let showAsTextOnly = canSave === false
  let isAdd = !currentCandidate.CandidateId
  return (
    <React.Fragment>
      <PersonalDetails showAsTextOnly={showAsTextOnly} validationRules={validationRules} currentCandidate={currentCandidate}
        genders={genders} qualificationsAutocomplete={qualificationsAutocomplete} candidateDetailsIntroText={candidateDetailsIntroText} titleHelpText={titleHelpText} showHelpText={showHelpText}  />
      <ContactDetails showAsTextOnly={showAsTextOnly} validationRules={validationRules} currentCandidate={currentCandidate} />
      <EmploymentDetails showAsTextOnly={showAsTextOnly} validationRules={validationRules} skillsAutocomplete={skillsAutocomplete} 
              qualificationsAutocomplete={qualificationsAutocomplete} cvUpload={cvUpload} downloadCv={downloadCv} removeCv={removeCv} currentCandidate={currentCandidate} 
              isGovernment={isGovernment} stateGovtEmployeeLink={stateGovtEmployeeLink} candidateBoards={candidateBoards} 
              updateCandidateBoards={updateCandidateBoards} showBoardExpirience={showBoardExpirience} showHelpText={showHelpText} linkedInHelpText={linkedInHelpText} canSave={canSave}/>
      <SkillsAndQualifications showAsTextOnly={showAsTextOnly} validationRules={validationRules} skillsAutocomplete={skillsAutocomplete} 
              qualificationsAutocomplete={qualificationsAutocomplete} currentCandidate={currentCandidate} isGovernment={isGovernment}
               qualificationsHelpText={qualificationsHelpText} skillsExpertiseHelpText={skillsExpertiseHelpText} showHelpText={showHelpText} anyCommentsHelpText={anyCommentsHelpText}  />
      {isAdd === true && <LoginDetails showAsTextOnly={showAsTextOnly} validationRules={validationRules} isAdd={isAdd} cvUpload={cvUpload} currentCandidate={currentCandidate} />}
      {isAdd === false && (isAdmin === true || isGovernment === true) && <CandidateCommunications validationRules={validationRules} communicationsHelpText={communicationsHelpText} showHelpText={showHelpText} />}
      {isAdd === false && isAdmin === true && <RejectReason showAsTextOnly={showAsTextOnly} validationRules={validationRules} />}
      {isAdd === true && <Declaration showAsTextOnly={showAsTextOnly} validationRules={validationRules} declarationText={declarationText} />}
    </React.Fragment>
  )
}

export default CandidateDetails



// WEBPACK FOOTER //
// ./src/components/candidate/candidate-details.js